import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router-dom";
import * as React from "react";
import Box from "@mui/material/Box";
import {
  Fade,
  Slide,
} from "@mui/material";
import {
  TrendingUp,
  Assessment,
  Business,
} from "@mui/icons-material";

import { AdminNavbar, ADMIN_DRAWER_WIDTH } from "../shared-components/sidebar/SideBar";

export default function AdminStickLayout(props: any): React.ReactElement {

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden', display: 'flex' }}>
      {/* Left sidebar (desktop: permanent, mobile: drawer) */}
      <AdminNavbar />
      {/* Spacer so main content gets exact width (viewport - drawer) on desktop */}
      <Box
        sx={{
          width: ADMIN_DRAWER_WIDTH,
          flexShrink: 0,
          display: { xs: 'none', md: 'block' },
        }}
      />
      {/* Main content: fills remaining width next to sidebar */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          minHeight: '100vh',
          pt: { xs: '56px', md: 0 },
          pl: 0,
          pr: { xs: 2, sm: 2.5, md: 3 },
          pb: { xs: 2, sm: 3, md: 4 },
          boxSizing: 'border-box',
        }}
      >
        <ErrorBoundary fallback={<div>Something went wrong</div>}>
          <Outlet />
        </ErrorBoundary>
      </Box>

      {/* Global Styles */}
      <Box
        component="style"
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes shimmer {
              0% { background-position: -200% 0; }
              100% { background-position: 200% 0; }
            }
            @keyframes pulse {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.05); }
            }
          `
        }}
      />
    </Box>
  );
}
